<template>
  <div class="wrapper">
    <div>
      <vxe-button status="my-orange" icon="fa fa-plus" @click="addProduct()">添加服务项目</vxe-button>
    </div>
    <div style="margin-top: 20px">
      <el-table :data="tableData" border show-overflow-tooltip style="width: 100%">
        <el-table-column align="center" prop="name" label="服务项目名称"/>
        <el-table-column align="center" prop="price" label="金额（元/小时）"/>
        <el-table-column align="center" prop="duration" label="时长（元/小时）"/>
        <el-table-column align="center" prop="description" label="服务内容说明"/>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editClick(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="delproduct(scope.row)">删除</el-button>
            <el-switch style="margin-left: 10px" @change="powerChange($event,scope.row)"
                       v-model="scope.row.ifVisibleBool" active-color="#2EBC21" inactive-color="#CACACA">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <vxe-pager
        :current-page.sync="tablePage.currentPage"
        :page-size.sync="tablePage.pageSize"
        :page-sizes="tablePage.pageSizes"
        :total="tablePage.totalResult"
        :layouts="layouts"
        @page-change="pageChange"
      />
    </div>

    <el-dialog title="添加服务项目" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
      <el-form :model="form" label-position="left">

        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="服务金额" :label-width="formLabelWidth">
          <el-input v-model="form.price" type="number" autocomplete="off">
            <template slot="append">元/小时</template>
          </el-input>
        </el-form-item>
        <el-form-item label="服务时长" :label-width="formLabelWidth">
          <el-input v-model="form.duration" type="number" autocomplete="off">
            <template slot="append">小时</template>
          </el-input>
        </el-form-item>
        <el-form-item label="服务内容说明" :label-width="formLabelWidth">
          <el-input v-model="form.description" type="textarea" autocomplete="off"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="()=>{dialogFormVisible = false,form={}}">取 消
        </el-button>
        <el-button type="primary" @click="addOrEdit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import UploadImg from '@/components/UploadImg.vue'
import axios from 'axios'
import api from '@/store/API/api'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'

export default {
  components: {
    UploadImg, ...CustomTemplate
  },
  data() {
    return {
      btndisabled: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      chooseId: '',
      form: [],
      pictureList: [],
      qualityInspectReportList: [],
      fileData: null,
      fileName: '',
      importVisible: false,
      uploadLoading: false,
      tableData: [],
      // ismore:false,
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true
      }
    }
  },
  created() {
    this.getLists()
  },
  computed: {
    ...mapState([
      'layouts'
    ])
  },
  methods: {
    ...mapActions([
      'serviceProductList',
      'serviceProductAdd',
      'serviceProductUpdate',
      'serviceProductDel',
      'serviceProductDetail'
    ]),
    // 分页功能
    pageChange(item) {
      if (item.type === 'size') {
        this.tablePage.currentPage = 1
      } else {
        this.tablePage.currentPage = item.currentPage
      }
      this.getLists()
    },
    // 查询列表
    getLists() {
      const params = {
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      }
      this.serviceProductList(params).then(res => {
        if (res.code === 200) {
          res.data.dataList.forEach(item => {
            item.ifVisibleBool = item.ifVisible === 1
          })
          this.tableData = res.data.dataList
          this.tablePage.totalResult = res.data.total
        }
      })
    },
    powerChange(e, row) {
      row.ifVisible = e ? 1 : 0
      this.serviceProductUpdate(row)
    },
    // 删除
    delproduct(row) {
      this.$XModal.confirm('您确定要删除该数据?').then(type => {
        if (type === 'confirm') {
          const params = row.id
          this.serviceProductDel(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getLists()
            }
          })
        } else {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }
      })
    },
    addProduct() {
      this.dialogFormVisible = true
      this.form = {}
      this.qualityInspectReportList = []
      this.pictureList = []
      this.chooseId = ''
    },
    editClick(row) {
      this.chooseId = row.id
      this.serviceProductDetail(this.chooseId).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = true
          this.form = {
            ...res.data
          }
        }
      })
    },
    addOrEdit() {
      if (this.chooseId === '') {
        this.serviceProductAdd(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.form = {}
            this.dialogFormVisible = false
            this.getLists()
          }
        })
      } else {
        this.serviceProductUpdate(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.form = {}
            this.dialogFormVisible = false
            this.getLists()
          }
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: auto;

  .page {
    overflow: initial;
  }
}

.w-100 {
  width: 100% !important;
}

v-deep .el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
